__turbopack_context__.v({
  "accordionSlideOverwrite": "externalRegistrationModal-module-scss-module__ggkSQG__accordionSlideOverwrite",
  "content": "externalRegistrationModal-module-scss-module__ggkSQG__content",
  "datePicker": "externalRegistrationModal-module-scss-module__ggkSQG__datePicker",
  "fadeIn": "externalRegistrationModal-module-scss-module__ggkSQG__fadeIn",
  "fadeOut": "externalRegistrationModal-module-scss-module__ggkSQG__fadeOut",
  "footer": "externalRegistrationModal-module-scss-module__ggkSQG__footer",
  "form": "externalRegistrationModal-module-scss-module__ggkSQG__form",
  "formItem": "externalRegistrationModal-module-scss-module__ggkSQG__formItem",
  "giveawayBanner": "externalRegistrationModal-module-scss-module__ggkSQG__giveawayBanner",
  "header": "externalRegistrationModal-module-scss-module__ggkSQG__header",
  "inputLabel": "externalRegistrationModal-module-scss-module__ggkSQG__inputLabel",
  "logInForm": "externalRegistrationModal-module-scss-module__ggkSQG__logInForm",
  "overlay": "externalRegistrationModal-module-scss-module__ggkSQG__overlay",
  "placeholder": "externalRegistrationModal-module-scss-module__ggkSQG__placeholder",
  "registrationModal": "externalRegistrationModal-module-scss-module__ggkSQG__registrationModal",
  "row": "externalRegistrationModal-module-scss-module__ggkSQG__row",
  "scaleIn": "externalRegistrationModal-module-scss-module__ggkSQG__scaleIn",
  "scaleOut": "externalRegistrationModal-module-scss-module__ggkSQG__scaleOut",
  "signIn": "externalRegistrationModal-module-scss-module__ggkSQG__signIn",
  "submitButton": "externalRegistrationModal-module-scss-module__ggkSQG__submitButton",
  "successContent": "externalRegistrationModal-module-scss-module__ggkSQG__successContent",
  "successDescription": "externalRegistrationModal-module-scss-module__ggkSQG__successDescription",
  "successImage": "externalRegistrationModal-module-scss-module__ggkSQG__successImage",
  "successModal": "externalRegistrationModal-module-scss-module__ggkSQG__successModal",
  "successTitle": "externalRegistrationModal-module-scss-module__ggkSQG__successTitle",
  "title": "externalRegistrationModal-module-scss-module__ggkSQG__title",
  "volunteerHeader": "externalRegistrationModal-module-scss-module__ggkSQG__volunteerHeader",
  "volunteerTitle": "externalRegistrationModal-module-scss-module__ggkSQG__volunteerTitle",
  "zoomIn": "externalRegistrationModal-module-scss-module__ggkSQG__zoomIn",
  "zoomOut": "externalRegistrationModal-module-scss-module__ggkSQG__zoomOut",
});
